/**
 * History Item Date Component
 * Displays the formatted date and time for a history entry
 * Follows SRP - single responsibility for date/time rendering
 */

import React from 'react';
import { typography, fontPrimary, spacing } from '@/design-system/utils';

interface HistoryItemDateProps {
  date: string;
  time?: string;
}

export const HistoryItemDate: React.FC<HistoryItemDateProps> = ({
  date,
  time,
}) => {
  if (!date && !time) {
    return null;
  }

  return (
    <span
      style={{
        color: '#000',
        fontFamily: fontPrimary,
        fontSize: typography.size.base,
        fontStyle: 'normal',
        fontWeight: typography.weight.regular,
        lineHeight: 'normal',
      }}
    >
      {time && (
        <>
          {time}
          <span style={{ margin: `0 ${spacing[1]}` }}>·</span>
        </>
      )}
      {date}
    </span>
  );
};
